import React from 'react';
import * as R from 'ramda';
import {Maybe} from 'monet';

import querystring from 'querystring';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import DownloadFileButton from '@/views/shared/DownloadFileButton';

const Content = ({formData}) => {
  const {t: tr} = useTranslation();

  const queryParams = R.compose(
    R.ifElse(R.equals(undefined), R.always(formData), val =>
      R.merge(formData, {excludeStatus: R.join(',', val)})
    ),
    R.prop('excludeStatus')
  );

  const exportUrl = () =>
    `/b2b/report_export?${querystring.stringify(queryParams(formData))}`;

  return (
    <Row>
      <Col md={12}>
        <DownloadFileButton className='btn btn-secondary' path={exportUrl()}>
          {tr('report:export')}
        </DownloadFileButton>
      </Col>
    </Row>
  );
};

const ExportButton = ({formData}) =>
  Maybe.fromFalsy(formData.reportType)
    .map(() => <Content formData={formData} />)
    .orNull();

export default ExportButton;
